<template>
  <div class="wg-row com-anm22-app-inner-wrapper">
    <!-- TITOLO PAGINA -->
    <div class="wg-row">
      <div class="com-anm22-page-title" style="font-size:24px;">
        {{ $anm22.strLang(lang, 'Analytics', 'Statistiche') }}
      </div>
    </div>
    <div class="vertical-height-div" style="height:10px;"></div>
    <!-- Filtri -->
    <div class="wg-row" style="flex-wrap:nowrap;align-items:center;">
      <div class="com-anm22-app-text-l">{{ $anm22.strLang(lang, 'From', 'Da') }}</div>
      <div class="horizontal-height-div" style="width:10px;"></div>
      <input type="date" v-model="from">
      <div class="horizontal-height-div" style="width:10px;"></div>
      <div class="com-anm22-app-text-l">{{ $anm22.strLang(lang, 'To', 'A') }}</div>
      <div class="horizontal-height-div" style="width:10px;"></div>
      <input type="date" v-model="to">
      <div class="horizontal-height-div" style="width:10px;"></div>
      <input 
          type="button" 
          :value="$anm22.strLang(lang, 'Update', 'Aggiorna')"
          @click="loadData"
      >
    </div>
    <div class="vertical-height-div" style="height:20px;"></div>
    <div class="wg-row" style="height:calc(100vh - 228px);">
      <world-sub-menu 
          :selected="chartId"
          :list="list"
          @changePage="selectChart">
        <div v-if="chartsLoaded"  slot="content" class="wg-row">
          <div v-if="loadingChartData" class="wg-row" style="margin:10px;justify-content:center;">
            <vue-simple-spinner size="medium" :line-fg-color="appColor"/>
          </div>
          <component 
              v-else
              :timezone="timezone"
              :data="chartData" 
              :from="from"
              :to="to"
              :is="chartComponent"></component>
        </div>
      </world-sub-menu>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import WorldSubMenu from "../../../../../world/spa/components/WorldSubMenu.vue";
import AnalyticsComponents from '../../components/analytics/index';
import Spinner from "vue-simple-spinner";

export default {
  data() {
    return {
      loading: true,
      chartsLoaded: false,
      loadingChartData: true,
      invoicesEmitted: 0,
      from: null,
      to: null,
      /* Array caricati dinamicamente e non salvati offline */
      chartId: 'orders',
      chartComponent: 'OrderAnalytics',
      chartData: null
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang,
      licenseSelected: state => state.licenseSelected,
      windowWidth: state => state.windowWidth,
      isOffline: state => state.offline.isOffline,
      appColor: state => state.config.appColor
    }),
    license() {
      return this.$store.getters['foodLicenses/getByHash'](this.licenseSelected);
    },
    work() {
      return this.$store.getters['works/get'](this.license.work);
    },
    timezone() {
      return this.work.timezone;
    },
    list() {
      return [
        {
          id: "orders",
          img: this.$anm22.icons.getWorldIcon('menuAnalyticsOrange'),
          label: this.$anm22.strLang(this.lang, "Orders", "Ordini"),
          component: 'OrderAnalytics'
        },
        {
          id: "products",
          img: this.$anm22.icons.getWorldIcon('menuAnalyticsOrange'),
          label: this.$anm22.strLang(this.lang, "Products", "Prodotti"),
          component: 'ProductAnalytics'
        },
        {
          id: "invoices",
          img: this.$anm22.icons.getWorldIcon('vatCode'),
          label: this.$anm22.strLang(this.lang, "Invoices", "Fatture"),
          component: 'InvoiceAnalytics'
        }
      ];
    },
  },
  methods: {
    loadGCharts() {
      //Load google charts
      const head = document.getElementsByTagName("head")[0];
      if (window.google && window.google.charts) {
        this.chartsLoaded = true;
        return;
      }
      const script = document.createElement('script');
      script.src = "https://www.gstatic.com/charts/loader.js";
      script.onload = () => this.chartsLoaded = true;
      head.appendChild(script);
    },
    loadPage() {
      this.loading = true;
      this.$http.get('analytics')
        .then(response => {
          return Promise.all([
            this.$store.dispatch("works/update", {
                vlf: this.$vlf("works"),
              objs: response.data.works
            })
          ])
        })
        .then(() => {
          this.loading = false;
          this.$Progress.finish();
          this.from = this.$moment().tz(this.timezone).startOf('day').subtract(10, 'days').format('YYYY-MM-DD');
          this.to = this.$moment().tz(this.timezone).endOf('day').format('YYYY-MM-DD');
          this.loadData();
        })
    },
    loadData(from, to) {
      this.loadingChartData = true;
      this.$Progress.start();
      this.$http.get('analytics/chart-data?from='+this.from+'&to='+this.to)
        .then(response => {
          this.loadingChartData = false;
          this.$Progress.finish();
          this.chartData = response.data;
        });
    },
    selectChart(listItem) {
      this.chartId = listItem.id;
      this.chartComponent = listItem.component;
    }
  },
  created() {
    document.title = this.$anm22.strLang(this.lang, 'Analytics', 'Statistiche');
    this.$store.dispatch(
      "headbar/setHeadbarTitle",
      this.$anm22.strLang(this.lang, 'Analytics', 'Statistiche')
    );
    this.loadGCharts();
    this.loadPage();
  },
  components: {
    WorldSubMenu,
    "vue-simple-spinner": Spinner,
    ...AnalyticsComponents
  }
}
</script>

<style lang="scss" scoped>
.select-chart-container {
  border: 1px solid #eee;
  border-radius: 2px;
  box-shadow: 0 2px 5px 0 #ccc;
  background: #fff;
  padding: 20px;
}
</style>
